var $=jQuery;
$(document).ready(function () {
  //Footer click
   $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  
    var $items = $("#eventGrid .event-card");
    var itemsToShow = 8;
    var visible = 0;

    $items.hide();

    function showNextItems() {
      $items.slice(visible, visible + itemsToShow).fadeIn();
      visible += itemsToShow;

      if (visible >= $items.length) {
        $("#loadMoreEvents").fadeOut();
      }
    }

    showNextItems();

    $("#loadMoreEvents").on("click", function () {
      showNextItems();
    });


   $('.notification-close').click(function (e) { 
        e.preventDefault();
        $('.notification-bar').slideUp();
    });
  
    $('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
          $(this).siblings('.acc-content').slideUp();
          $(this).removeClass('active');
        }
        else {
          $('.acc-content').slideUp();
          $('.acc-head').removeClass('active');
          $(this).siblings('.acc-content').slideToggle();
          $(this).toggleClass('active');
        }
    });
  //Point Section
$(".hotspot-point").click(function (event) {

    let productHandle = $(this).data("product");
    let infoBox = $(this).next(".hotspot-product-info");

    if (productHandle) {
        $.getJSON(`/products/${productHandle}.json`, function (data) {
            let product = data.product;
            let vendor = product.vendor;
            let variant = product.variants[0];
            let unitPrice = variant.unit_price;
            let unitPriceMeasurement = variant.unit_price_measurement;
            let unitPriceHtml = '';
            if (unitPrice && unitPriceMeasurement && unitPriceMeasurement.reference_unit) {
                unitPriceHtml = `
                    <span class="unit-price">
                       (${(unitPrice)} €/${unitPriceMeasurement.reference_unit} )
                    </span>
                `;
            }
            console.log(unitPrice); 
          
            let imageHtml = '';
            if (product.image && product.image.src) {
                imageHtml = `
                  <a href="/products/${product.handle}" class="hotspot-image-link">
                      <img src="${product.image.src}" class="hotspot-product-img">
                  </a>
                `;
            }

            let productHtml = `
                ${imageHtml}
                <a href="/products/${product.handle}" class="hotspot-title-link">
                    <p class="product-vendor">${vendor}</p>
                    <h3>${product.title}</h3>
                    <p>
                      ${variant.price} ${unitPriceHtml} 

                    </p>
                </a>
            `;

            infoBox.find(".hotspot-product-content").html(productHtml);
            $(".hotspot-product-info").hide(); 
            infoBox.fadeIn();
        });
    }

    event.stopPropagation(); 
});

   $(document).click(function (event) {
        if (!$(event.target).closest(".hotspot-product-info, .hotspot-point").length) {
            $(".hotspot-product-info").fadeOut();
        }
    });
  //End Point Section

    const $loadMoreButton = $('[data-pagination-btn]');
    if ($loadMoreButton.length) {
          const $productGrid = $('#product-grid');
        $loadMoreButton.on('click', function(e) {
            e.preventDefault();
            const nextUrl = $loadMoreButton.attr('href');

            $loadMoreButton.text("Laden...");
            $loadMoreButton.prop('disabled', true);

            $.get(nextUrl, function(response) {
                const $tempDiv = $('<div>').html(response);
                const newProductsHtml = $tempDiv.find('#product-grid').html();

                $productGrid.append(newProductsHtml);

           

                const $newButton = $tempDiv.find('[data-pagination-btn]');
                const newHref = $newButton.attr('href');

                if ($newButton.length && newHref && newHref !== nextUrl) {
                    $loadMoreButton.attr('href', newHref);
                    $loadMoreButton.text("MEHR ANZEIGEN");
                    $loadMoreButton.prop('disabled', false);
                } else {
                    $loadMoreButton.text("Keine Produkte mehr").hide(); 
                }
            }).fail(function() {
                console.error('Error loading more products.');
                $loadMoreButton.text("Try again");
                $loadMoreButton.prop('disabled', false);
            });
        });
    }
  
});